import { computed, observable } from 'mobx'
import { AppStore } from '~/stores/AppStore'
// import _ from 'lodash'

export class Controller {
  private store: AppStore = null

  // Options
  public maxUnfoldedCards = 3 // How many cards we leave unfolded
  public maxDesc = 200 // Max description length

  @observable public isExpanded = false
  @observable public destroy = false

  constructor(store) {
    this.store = store
  }

  @computed get isFolded() {
    return !this.isExpanded && this.store.notificationsPopover.length > this.maxUnfoldedCards
  }

  public destroyAllNotifications = (instant = false) => {
    this.store.notificationsPopover.forEach((n, i) => {
      n.selfDestruct(this.store.notificationsPopover.length - i, instant)
    })

    if (instant) {
      this.destroy = true

      setTimeout(() => {
        this.store.notificationsPopover = []
        this.destroy = false
      }, 200)
    }
  }

  public calculateOffset = (offset) => {
    let totalHeight = 0

    this.store.notificationsPopover.forEach((not, i) => {
      if (i < offset) {
        totalHeight += not.height
      }
    })

    if (isNaN(totalHeight)) {
      return 0
    }

    return totalHeight + (this.maxUnfoldedCards - 1) * 10
  }

  public triggerCollapse = () => {
    this.isExpanded = false
    this.destroyAllNotifications()
  }

  public getNotificationStyle = (totHeight, index, data, destroy) => {
    let cardHeightOffset = this.store.notificationsPopover[0].height
    let offset = 0
    let fixedTotHeight = 0
    const minCardHeight = 44

    const style: any = {
      top: totHeight + index * 10,
      height: data.height,
      opacity: destroy ? 0 : 1,
      zIndex: this.store.notificationsPopover.length - index
    }

    if (this.store.notificationsPopover.length > this.maxUnfoldedCards) {
      cardHeightOffset = this.store.notificationsPopover[this.maxUnfoldedCards - 1].height
      offset = this.maxUnfoldedCards
      fixedTotHeight = this.calculateOffset(offset)
    }

    if (this.isFolded) {
      if (index >= offset && cardHeightOffset) {
        if (index === offset) {
          style.top = fixedTotHeight - cardHeightOffset + (cardHeightOffset - minCardHeight + 10)
          style.transform = 'scale(0.95)'
          style.opacity = 0.8
        } else if (index === offset + 1) {
          style.top = fixedTotHeight - cardHeightOffset + (cardHeightOffset - minCardHeight + 20)
          style.transform = 'scale(0.90)'
          style.opacity = 0.7
        } else {
          style.top = fixedTotHeight - cardHeightOffset + (cardHeightOffset - minCardHeight + 20)
          style.boxShadow = 'unset'
          style.transform = 'scale(0.90)'
          style.opacity = 0
        }

        style.height = minCardHeight
      } else {
        style.top = totHeight + index * 10
      }
    }

    return style
  }
}
